import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoataxi() {



const cardData =
{
  keyword: 'Pune to Goa Taxi  ',

  heading: 'Lotus Cab: Pune to Goa Taxi  ',

headingDescription:
  "Lotus Cabs provides reliable and affordable Pune to Goa Taxi services for family vacations, corporate travel, business trips, airport transfers, student travel, weekend getaways, sightseeing tours, and one-way or round-trip journeys. Our premium fleet includes Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus, driven by professional and experienced chauffeurs for a safe and comfortable ride. With 24x7 booking support, transparent pricing, doorstep pickup from any location in Pune, well-maintained vehicles, and dependable long-distance highway travel, Lotus Cabs ensures a smooth, convenient, and hassle-free journey from Pune to Goa.",

  top: 'Top Places to Visit in Goa before Traveling to Pune with Lotus Cab',

topPlaces: [
    {
        title: "Vagator Beach",
        description:
            "Vagator Beach is a scenic coastal destination known for its dramatic red cliffs, soft golden sand, and breathtaking sunsets over the Arabian Sea. The beach offers a peaceful atmosphere, trendy cafés, and stunning viewpoints, making it a favorite among photographers and couples."
    },
    {
        title: "Colva Beach",
        description:
            "Colva Beach is one of South Goa's most beautiful beaches, stretching for several kilometers with soft white sand and swaying coconut palms. Visitors enjoy swimming, beach walks, water sports, seafood restaurants, and a relaxing coastal ambiance."
    },
    {
        title: "Se Cathedral",
        description:
            "Se Cathedral is one of the largest churches in Asia and a remarkable example of Portuguese-Gothic architecture. Dedicated to Saint Catherine, the cathedral is admired for its grand interiors, historic significance, and the famous Golden Bell."
    },
    {
        title: "Church of Our Lady of the Immaculate Conception",
        description:
            "Located in Panaji, the Church of Our Lady of the Immaculate Conception is famous for its iconic white façade, elegant stairways, and centuries-old history. It is one of Goa's most photographed landmarks and offers beautiful views of the city."
    },
    {
        title: "Butterfly Beach",
        description:
            "Butterfly Beach is a secluded paradise surrounded by lush forests and crystal-clear waters. Accessible mainly by boat or trekking, the beach is ideal for travelers seeking tranquility, dolphin sightings, and breathtaking natural beauty."
    },
    {
        title: "Arambol Beach",
        description:
            "Arambol Beach is popular for its bohemian vibe, live music, yoga retreats, and vibrant beachside cafés. The beach attracts backpackers and international travelers looking for a laid-back atmosphere and unforgettable sunset views."
    },
    {
        title: "Divar Island",
        description:
            "Divar Island is a peaceful river island that showcases Goa's traditional village life, Portuguese-era churches, scenic landscapes, and lush paddy fields. Visitors enjoy ferry rides, cycling, and exploring the island's rich cultural heritage."
    },
    {
        title: "Naval Aviation Museum",
        description:
            "The Naval Aviation Museum in Vasco da Gama displays vintage aircraft, helicopters, engines, and naval artifacts that highlight the history of the Indian Navy's aviation wing. It is an educational attraction for families and aviation enthusiasts."
    },
    {
        title: "Mollem National Park",
        description:
            "Mollem National Park is a biodiversity hotspot located in the Western Ghats, home to diverse wildlife, dense forests, waterfalls, and numerous trekking trails. Nature lovers visit the park to experience Goa's rich flora and fauna."
    },
    {
        title: "Fontainhas",
        description:
            "Fontainhas is Goa's charming Latin Quarter, famous for its colorful Portuguese-style houses, narrow winding streets, art galleries, cafés, and vibrant cultural heritage. Walking through this picturesque neighborhood offers a glimpse into Goa's colonial past."
    }
],





"services": [
  {
    "name": "Pune to Goa Taxi",
    "description": "Book a Pune to Goa taxi for comfortable and hassle-free intercity travel with professional drivers and well-maintained vehicles."
  },
  {
    "name": "Pune to Goa Taxi Service",
    "description": "Reliable Pune to Goa taxi service offering safe and affordable transportation for families, tourists, and business travelers."
  },
  {
    "name": "Pune to Goa Cab",
    "description": "Comfortable Pune to Goa cab service with flexible pickup options and a wide range of vehicles for long-distance travel."
  },
  {
    "name": "Pune to Goa Cab Service",
    "description": "Professional Pune to Goa cab service featuring AC vehicles, transparent pricing, and experienced chauffeurs."
  },
  {
    "name": "Pune to Goa Taxi Booking",
    "description": "Easy Pune to Goa taxi booking with instant confirmation, multiple vehicle choices, and dependable customer support."
  },
  {
    "name": "Pune to Goa Cab Booking",
    "description": "Convenient Pune to Goa cab booking service with quick reservations and hassle-free travel arrangements."
  },
  {
    "name": "Pune to Goa One Way Taxi",
    "description": "Affordable Pune to Goa one way taxi service allowing passengers to pay only for a single-side journey."
  },
  {
    "name": "Pune to Goa Round Trip Taxi",
    "description": "Flexible Pune to Goa round trip taxi packages suitable for family vacations, business visits, and weekend trips."
  },
  {
    "name": "Pune to Goa Outstation Taxi",
    "description": "Reliable Pune to Goa outstation taxi service for comfortable long-distance travel with professional drivers."
  },
  {
    "name": "Pune to Goa Airport Taxi",
    "description": "Convenient Pune to Goa airport taxi service with timely pickup and drop facilities for seamless travel."
  },
  {
    "name": "Pune to Goa Innova Taxi",
    "description": "Spacious Pune to Goa Innova taxi service perfect for family trips and group travel with ample luggage space."
  },
  {
    "name": "Pune to Goa Ertiga Taxi",
    "description": "Affordable Pune to Goa Ertiga taxi service with comfortable seating and economical fares for small groups."
  },
  {
    "name": "Pune to Goa Sedan Taxi",
    "description": "Comfortable Pune to Goa sedan taxi service ideal for solo travelers, couples, and business professionals."
  },
  {
    "name": "Pune to Goa SUV Taxi",
    "description": "Premium Pune to Goa SUV taxi service offering spacious interiors and comfortable long-distance travel."
  },
  {
    "name": "Pune to Goa Taxi Fare",
    "description": "Get transparent Pune to Goa taxi fare details with clear pricing based on vehicle type, tolls, and travel distance."
  },
  {
    "name": "Pune to Goa Taxi Price",
    "description": "Check Pune to Goa taxi price options for sedans, SUVs, and premium vehicles with no hidden charges."
  },
  {
    "name": "Pune to Goa Family Taxi",
    "description": "Comfortable Pune to Goa family taxi service with spacious vehicles suitable for family and group travel."
  },
  {
    "name": "Pune to Goa AC Taxi",
    "description": "Travel comfortably with Pune to Goa AC taxi service featuring air-conditioned vehicles and experienced drivers."
  },
  {
    "name": "Best Pune to Goa Taxi Service",
    "description": "Best Pune to Goa taxi service offering professional drivers, clean vehicles, timely pickups, and excellent customer support."
  },
  {
    "name": "Affordable Pune to Goa Taxi",
    "description": "Budget-friendly Pune to Goa taxi service providing comfortable travel at competitive prices without compromising quality."
  }
],

"tableData": [
  ["Pune to Goa Taxi", "Pune to Goa Taxi Service"],
  ["Pune to Goa Cab", "Pune to Goa Cab Service"],
  ["Pune to Goa Taxi Booking", "Pune to Goa Cab Booking"],
  ["Pune to Goa One Way Taxi", "Pune to Goa Round Trip Taxi"],
  ["Pune to Goa Outstation Taxi", "Pune to Goa Airport Taxi"],
  ["Pune to Goa Innova Taxi", "Pune to Goa Ertiga Taxi"],
  ["Pune to Goa Sedan Taxi", "Pune to Goa SUV Taxi"],
  ["Pune to Goa Taxi Fare", "Pune to Goa Taxi Price"],
  ["Pune to Goa Family Taxi", "Pune to Goa AC Taxi"],
  ["Best Pune to Goa Taxi Service", "Affordable Pune to Goa Taxi"]
],






"whychoose": [
  {
    "WhyChooseheading": "Comfortable Goa Getaway",
    "WhyChoosedescription": "Enjoy a relaxing journey from Pune to Goa with clean and comfortable taxis."
  },
  {
    "WhyChooseheading": "Affordable Taxi Fares",
    "WhyChoosedescription": "Competitive pricing with transparent billing and no hidden costs."
  },
  {
    "WhyChooseheading": "One Way & Round Trip Options",
    "WhyChoosedescription": "Choose flexible travel plans for one-way transfers or return journeys."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles",
    "WhyChoosedescription": "Book Sedan, Ertiga, Innova Crysta, and SUV taxis according to your group size."
  },
  {
    "WhyChooseheading": "Pickup from Any Location in Pune",
    "WhyChoosedescription": "Convenient pickup services from homes, hotels, airports, railway stations, and offices."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs",
    "WhyChoosedescription": "Experienced drivers ensure safe driving through highways and ghat sections."
  },
  {
    "WhyChooseheading": "Sanitized AC Vehicles",
    "WhyChoosedescription": "Travel in well-maintained and air-conditioned cabs for maximum comfort."
  },
  {
    "WhyChooseheading": "24/7 Booking Assistance",
    "WhyChoosedescription": "Our support team is available round the clock for bookings and travel assistance."
  }
]
};

const faqData = [
  {
    question: 'Does Lotus Cab provide Pune to Goa taxi service?',
    answer: 'Yes, Lotus Cab offers reliable Pune to Goa taxi services for one-way, round-trip, and customized travel requirements.'
  },
  {
    question: 'What is the distance between Pune and Goa by taxi?',
    answer: 'The road distance between Pune and Goa is approximately 450 km, and the journey generally takes around 8 to 10 hours.'
  },
  {
    question: 'What are the charges for Pune to Goa taxi booking?',
    answer: 'Taxi charges depend on the vehicle category, travel date, and trip type. Lotus Cab offers affordable and transparent pricing.'
  },
  {
    question: 'Can I book a one-way taxi from Pune to Goa?',
    answer: 'Yes, we provide economical one-way taxi services that are ideal for vacation and business travel.'
  },
  {
    question: 'Which vehicles are available for Pune to Goa travel?',
    answer: 'Our fleet includes Sedan cars, Ertiga, Innova Crysta, and SUVs suitable for solo travelers, families, and groups.'
  },
  {
    question: 'Do you provide airport pickup in Pune?',
    answer: 'Yes, Lotus Cab offers pickup services from Pune Airport, railway stations, hotels, and residential locations.'
  },
  {
    question: 'Are toll and parking charges included in the fare?',
    answer: 'Toll charges, parking fees, and state taxes are usually charged separately unless specifically included in the package.'
  },
  {
    question: 'Is night travel available from Pune to Goa?',
    answer: 'Yes, our taxi services are available day and night for comfortable long-distance travel.'
  },
  {
    question: 'Can I pre-book a taxi for my Goa trip?',
    answer: 'Absolutely. Advance booking is recommended to ensure your preferred vehicle is available on your travel date.'
  },
  {
    question: 'How can I book a Pune to Goa Taxi with Lotus Cab?',
    answer: 'You can book by sharing your pickup location, travel date, number of passengers, and preferred vehicle to receive instant fare details and confirmation.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Kulkarni',
    feedback: 'We planned a weekend trip to Goa and chose Lotus Cab for our travel. The cab was spacious, the driver was friendly, and the entire journey felt effortless.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Rachana Joshi',
    feedback: 'Traveling with children can be tiring, but this Pune to Goa taxi service made it enjoyable. The vehicle was clean, comfortable, and reached Goa right on schedule.',
    rating: 5,
  },
];









































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Goa Taxi",
"image": "https://lotuscab.com/assets/images/pune-to-goa-taxi.jpg",
"description": "Book Pune to Goa Taxi with Lotus Cab for safe, comfortable, and reliable outstation travel. Choose from one way, round trip, airport transfer, and private taxi services with sedan, Innova, Ertiga, and SUV cabs available 24x7 with professional drivers.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7215"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹18/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-goa-taxi"
}
};






  return (
    <div>
      
<Helmet>
  <title>Pune to Goa Taxi | One Way & Outstation Cab Service | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Goa Taxi with Lotus Cab for affordable and comfortable outstation travel. One way, round trip, airport transfer, and private taxi services with sedan, Innova, Ertiga, and SUV cabs available 24x7."
/>

<meta
 name="keywords"
 content="Pune to Goa Taxi, Pune to Goa Taxi Service, Pune to Goa Cab, Pune to Goa Cab Service, Pune to Goa Taxi Booking, Pune to Goa Cab Booking, Pune to Goa One Way Taxi, Pune to Goa Round Trip Taxi"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/96.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoataxi;